@use '@design/design-tokens/typography/typography' as *;

.legendRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  max-width: 60%;
}

.iconWrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.legendItemVector {
  height: 0;
  width: 16px;
  border-top: 1px solid;
  border-bottom: 1px solid;
}

.entityDetails {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.entityName {
  @include typography-v2-body-sm;
  color: var(--text-default);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.entityTag {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  flex-shrink: 0;
}

.proportionChange {
  font-family: var(--font-roboto-mono);
  align-self: flex-end;
  color: var(--text-soft);
  font-size: 16px;
  font-weight: 500;
  flex-shrink: 0;

  &.negative {
    color: var(--viz-bearish);
  }

  &.positive {
    color: var(--viz-bullish);
  }
}
